import { Config } from '../config';
import { EnumVariant, Tag, Tags, TagState } from '../interfaces';
import { HttpService } from './http.service';

const path = Config.API;
const tagDefinitionsPath = `${path}/event_tag_definitions`;

export abstract class TagsService {
  public static getAvailableTags = (): Promise<Tag[]> => {
    return HttpService.fetchAuthorized(tagDefinitionsPath, {
      method: 'GET',
    }).then((res) => res.tag_definitions.sort((a: Tag, b: Tag) => a.id.toString().localeCompare(b.id.toString())));
  };

  public static add = (tag: Tag): Promise<Tag> => {
    return HttpService.fetchAuthorized(tagDefinitionsPath, {
      method: 'POST',
      body: JSON.stringify({ ...tag }),
    }).then((res) => res);
  };

  public static update = (tag: Partial<Tag>): Promise<Tag> => {
    if (!tag.id) {
      throw new Error('Tag id is required for update');
    }

    return HttpService.fetchAuthorized(`${tagDefinitionsPath}/${tag.id}/metadata`, {
      method: 'PUT',
      body: JSON.stringify({ ...tag }),
    }).then((res) => res);
  };

  public static addVariant = (tag: Partial<Tag>, variant: Partial<EnumVariant>): Promise<Tag> => {
    if (!tag.id) {
      throw new Error('Tag id is required for variant creation');
    }

    return HttpService.fetchAuthorized(`${tagDefinitionsPath}/${tag.id}/enums`, {
      method: 'POST',
      body: JSON.stringify({ ...variant }),
    }).then((res) => res);
  };

  public static updateVariant = (tag: Partial<Tag>, variant: Partial<EnumVariant>): Promise<Tag> => {
    if (!tag.id) {
      throw new Error('Tag id is required for update');
    }

    return HttpService.fetchAuthorized(`${tagDefinitionsPath}/${tag.id}/enums/${variant.id}/metadata`, {
      method: 'PUT',
      body: JSON.stringify({ ...variant, name: variant.variant_name }),
    }).then((res) => res);
  };

  public static disable = (tag: Partial<Tag>): Promise<Tag> => {
    return TagsService.update({ ...tag, state: TagState.Disabled });
  };

  public static enable = (tag: Partial<Tag>): Promise<Tag> => {
    return TagsService.update({ ...tag, state: TagState.Active });
  };

  public static getTagsForEvent = (eventId: number): Promise<Tags> => {
    return HttpService.fetchAuthorized(`${path}/events/${eventId}/tags`, {
      method: 'GET',
    }).then((res) => res.tags);
  };

  public static addTagsToEvent = (tags: Tags, eventId: number): Promise<Tag> => {
    return HttpService.fetchAuthorized(`${path}/events/${eventId}/tags`, {
      method: 'POST',
      body: JSON.stringify({ tags }),
    }).then((res) => {
      return res;
    });
  };

  public static removeTagsFromEvent = (tag_ids: number[], eventId: number): Promise<Tag> => {
    return HttpService.fetchAuthorized(`${path}/events/${eventId}/tags`, {
      method: 'DELETE',
      body: JSON.stringify({ tag_ids }),
    }).then((res) => {
      return res;
    });
  };
}
